var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCesta = function SvgIconCesta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 34 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cesta",
    transform: "translate(-789 -32.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_456",
    "data-name": "Elipse 456",
    transform: "translate(789 32.081)",
    fill: "none",
    stroke: "#4b4b4b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9390",
    "data-name": "Grupo 9390",
    transform: "translate(795.44 41.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6333",
    "data-name": "Caminho 6333",
    d: "M1145.025-492.007v-3.017a1.258,1.258,0,0,1,1.461-.978h2.576v-.246c0-.713-.005-1.427,0-2.14a2.705,2.705,0,0,1,2.647-2.669q3.762-.021,7.524,0a2.633,2.633,0,0,1,2.587,2.294c.072.624.036,1.261.045,1.892,0,.284,0,.567,0,.871h.238c.85,0,1.7,0,2.549,0a1.187,1.187,0,0,1,1.25,1.257c0,.788,0,1.576,0,2.365a1.2,1.2,0,0,1-1.318,1.331c-.148,0-.209.035-.238.193q-.618,3.436-1.251,6.87a1.17,1.17,0,0,1-1.255,1.035H1149.1a1.184,1.184,0,0,1-1.251-1.044q-.541-2.964-1.076-5.929c-.068-.371-.139-.742-.205-1.1a5.269,5.269,0,0,1-.692-.084A1.231,1.231,0,0,1,1145.025-492.007Zm14.642-4c0-.769,0-1.521,0-2.274a.514.514,0,0,0-.576-.579q-3.618,0-7.235,0a.532.532,0,0,0-.592.591c0,.706,0,1.413,0,2.119,0,.045.007.091.011.143Zm.032,6.573c0-.754,0-1.507,0-2.261a.822.822,0,0,0-.686-.838.805.805,0,0,0-.91.551,1.393,1.393,0,0,0-.046.4q0,2.128,0,4.257a1.82,1.82,0,0,0,.02.3.8.8,0,0,0,.7.647.818.818,0,0,0,.928-.862C1159.7-487.971,1159.7-488.7,1159.7-489.437Zm-3.4-.006c0-.72,0-1.439,0-2.159a1.344,1.344,0,0,0-.045-.381.806.806,0,0,0-.908-.553.819.819,0,0,0-.687.816c-.008.543,0,1.086,0,1.629,0,.951,0,1.9,0,2.851a.818.818,0,0,0,.8.871.808.808,0,0,0,.837-.854C1156.3-487.963,1156.3-488.7,1156.3-489.443Zm-3.4-.016h0q0-1.09,0-2.179a1.226,1.226,0,0,0-.023-.283.811.811,0,0,0-.9-.618.807.807,0,0,0-.708.813q-.006,2.271,0,4.542a.787.787,0,0,0,.02.181.812.812,0,0,0,.9.628.8.8,0,0,0,.718-.8C1152.9-487.937,1152.9-488.7,1152.9-489.458Z",
    transform: "translate(-1145.025 501.067)",
    fill: "#191750"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCesta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_cesta.cae10cf4.svg";
export { ForwardRef as ReactComponent };